import API from "../../../../app/api";
export const getPolicyBySlug = async (slug) => {
    const res = await API.get(`/policy/${slug}`);

    if (!res.data?.success) {
        throw new Error(res.data?.message || "Failed to fetch About Us");
    }

    return res.data.data[0];
};
